export function addMeta(){
    const metaPaths = [
        {
            href: '/abase/style/?s=images/favicons/favicon.ico',
            type: 'image/x-icon',
            rel: 'icon',
        },
        {
            href: '/abase/style/?s=images/favicons/favicon.ico',
            type: 'image/x-icon',
            rel: 'shortcut icon',
        },
        {
            href: '/abase/style/?s=images/favicons/favicon-16x16.png',
            type: 'image/png',
            sizes: '16x16',
            rel: 'icon',
        },
        {
            href: '/abase/style/?s=images/favicons/favicon-32x32.png',
            type: 'image/png',
            sizes: '32x32',
            rel: 'icon',
        },
        {
            href: '/abase/style/?s=images/favicons/favicon-48x48.png',
            type: 'image/png',
            sizes: '48x48',
            rel: 'icon',
        },
        {
            href: '/abase/style/?s=images/favicons/apple-touch-icon-76x76.png',
            sizes: '76x76',
            rel: 'apple-touch-icon',
        },
        {
            href: '/abase/style/?s=images/favicons/apple-touch-icon-120x120.png',
            sizes: '120x120',
            rel: 'apple-touch-icon',
        },
        {
            href: '/abase/style/?s=images/favicons/apple-touch-icon-152x152.png',
            sizes: '152x152',
            rel: 'apple-touch-icon',
        },
        {
            href: '/abase/style/?s=images/favicons/apple-touch-icon-180x180.png',
            sizes: '180x180',
            rel: 'apple-touch-icon',
        },
    ];
    for (const element of metaPaths) {
        let linkCss = document.createElement('link');
        for (const key in element) {
            linkCss[key] = element[key];
        }
        linkCss.href = `${
            process.env.VUE_APP_API_HOST ? process.env.VUE_APP_API_HOST : ''
        }${element.href}`;
        if (typeof (document.head.appendChild) === "function") {
            document.head.appendChild(linkCss);
        }
    }
}

export function addCdnStyles(){
    const cdnStyles = [{
        href: '//cdn.aristosgroup.ru/fonts/roboto-condensed/font-lrb.css',
        rel: 'stylesheet'
    }]

    for (const element of cdnStyles) {
        let linkCss = document.createElement('link');
        for (const key in element) {
            linkCss[key] = element[key];
        }
        linkCss.href = element.href;
        document.head.appendChild(linkCss);
    }
}

export function addStylePage(){
    const globalStyles = '/abase/style/?s=css/aristos/compare/compare.less';
    const createLinkCss = document.createElement('link')
    createLinkCss.rel = 'stylesheet'
    createLinkCss.href = `${process.env.VUE_APP_API_HOST ? process.env.VUE_APP_API_HOST : ''}${globalStyles}`;
    document.head.appendChild(createLinkCss)
    return createLinkCss
}
export function addHeaderStyles(){
    const globalStyles = '/abase/style/?s=css/aristos/spa/header/header.less';
    const createLinkCss = document.createElement('link')
    createLinkCss.rel = 'stylesheet'
    createLinkCss.href = `${process.env.VUE_APP_API_HOST ? process.env.VUE_APP_API_HOST : ''}${globalStyles}`;
    document.head.appendChild(createLinkCss)
    return createLinkCss
}
export function addFooterStyles(){
    const globalStyles = '/abase/style/?s=css/aristos/spa/footer/footer.less';
    const createLinkCss = document.createElement('link')
    createLinkCss.rel = 'stylesheet'
    createLinkCss.href = `${process.env.VUE_APP_API_HOST ? process.env.VUE_APP_API_HOST : ''}${globalStyles}`;
    document.head.appendChild(createLinkCss)
    return createLinkCss
}

export function addExternalJsFiles(){
    const globalStyles = '/compare/aStorage.js';
    const createLinkScript = document.createElement('script')
    createLinkScript.src = `${process.env.VUE_APP_API_HOST ? process.env.VUE_APP_API_HOST : ''}${globalStyles}`;
    document.head.appendChild(createLinkScript)
    return createLinkScript
}

